import * as RequestTypeActionType from './constants';

const defaultParams = {
  searchKey: '',
  skip: 1,
  take: 10,
  sort: { field: 'type', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ManageRequestTypes = {
  items: [],
  params: defaultParams
};

const RequestTypeProfile = {
  id: '',
  name: '',
  buyerOrientation: false,
  homeOwner: false,
  isActive: true
};

const RequestTypeState = {
  ManageRequestTypes: ManageRequestTypes,
  RequestTypeProfile: RequestTypeProfile,
  ErrorMsg: [],
  IsOpenFormAddEdit: false,
  Title: 'New request type',
  IsCreate: true,
  dateTime: new Date(),
  ItemList: [],
  homeownerRequestTypeList: []
};

export default function RequestTypeStore(state = RequestTypeState, action) {
  switch (action.type) {
    case RequestTypeActionType.SEARCH_REQUEST_TYPE_SUCCESS:
      return processSearchSuccess(state, action);
    case RequestTypeActionType.OPEN_FORM_CREATE_REQUEST_TYPE:
      return {
        ...state,
        RequestTypeProfile: RequestTypeProfile,
        Title: 'New request type',
        ErrorMsg: [],
        IsCreate: true,
        IsOpenFormAddEdit: true,
        dateTime: new Date()
      };
    case RequestTypeActionType.CREATE_REQUEST_TYPE_ASYNC:
    case RequestTypeActionType.UPDATE_REQUEST_TYPE_ASYNC:
      return {
        ...state,
        ErrorMsg: []
      };
    case RequestTypeActionType.CLOSE_FORM_CREATE_REQUEST_TYPE:
      return {
        ...state,
        IsOpenFormAddEdit: false
      };
    case RequestTypeActionType.GET_REQUEST_TYPE_BY_ID_SUCCESS:
      return processGetByIdSuccess(state, action);
    case RequestTypeActionType.ADD_EDIT_REQUEST_TYPE_ERROR:
      return processAddEditError(state, action);
    case RequestTypeActionType.RESET_REQUEST_TYPE:
      return {
        ...state,
        ManageRequestTypes: ManageRequestTypes
      };
    case RequestTypeActionType.SELECT_LIST_ITEM_SUCCESS:
      return processSelectItemSuccess(state, action);

    case RequestTypeActionType.GET_HOMEOWNER_REQUEST_TYPE_LIST_SUCCESS:
      return {
        ...state,
        homeownerRequestTypeList: action.data
      };
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var manageRequestTypes = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageRequestTypes: manageRequestTypes,
    ErrorMsg: [],
    IsOpenFormAddEdit: false
  };
};

const processGetByIdSuccess = (state, action) => {
  return {
    ...state,
    RequestTypeProfile: action.data,
    Title: 'Edit request type',
    ErrorMsg: [],
    IsCreate: false,
    IsOpenFormAddEdit: true
  };
};

const processAddEditError = (state, action) => {
  return {
    ...state,
    ErrorMsg: [action.data.error],
    RequestTypeProfile: {
      ...state.RequestTypeProfile,
      name: action.data.params.name
    }
  };
};

const processSelectItemSuccess = (state, action) => {
  return {
    ...state,
    ItemList: action.data
  };
};



// WEBPACK FOOTER //
// ./src/Request-Types/reducers.js